<template>
  <div class="users-container">
    <div class="header">
      <h2 class="header__title">
        <span class="header__icon">📊</span>
        Usuarios en Línea
      </h2>
      <button @click="fetchAndUpdateCounts" class="refresh-btn">
        <i class="uil-sync"></i>
        <span>Actualizar</span>
      </button>
    </div>

    <div class="grid-card">
      <div class="roulette-card" v-for="roulette in roulettesWithCount" :key="roulette.id">
        <div class="card-glow"></div>
        
        <div class="card-header">
          <div class="card-thumb">
            <img :src="roulette.logo"
                 :alt="roulette.name"
                 @error="handleImageError(roulette)"
                 loading="lazy">
          </div>
          <div class="status-indicator">
            <span class="status-dot"></span>
          </div>
        </div>

        <div class="card-body">
          <h3 class="card-title">{{ roulette.name }}</h3>
          
          <div class="card-count">
            <span class="count-number">{{ roulette.animatedCount }}</span>
            <div class="count-label">
              <i class="uil-users-alt"></i>
              <span>{{ roulette.animatedCount === 1 ? 'usuario' : 'usuarios' }}</span>
            </div>
          </div>
        </div>

        <div class="card-footer">
          <div class="activity-bar">
            <div class="activity-fill" :style="{ width: getActivityWidth(roulette.animatedCount) }"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { GamesTypes } from '../../../../state/helpers/gamesTypes';

export default {
  name: 'CounterUsersConnected',
  props: {
    // Prop opcional para configurar la duración de la animación
    animationDuration: {
        type: Number,
        default: 1500 // 1.5 segundos
    },
    // Prop opcional para configurar el intervalo de actualización
    refreshInterval: {
        type: Number,
        default: 120000 // 2 minutos
    }
  },
data() {
    return {
        roulettes: [
        {
          name: 'Roulette 1',
          id: '61e4e0b8c9b9d1d6c1a5a2a3',
          logo: 'https://images.kbapi.net//images/Sprint/primero/SPACE%20ROULETTE_2_optimized.gif',
        targetCount: 150
        },
      ],
      // 1. Inicializa el array con la propiedad reactiva 'animatedCount'
      roulettesWithCount: [],
      intervalId: null, // Para guardar el ID del temporizador y limpiarlo
      PLACEHOLDER_IMAGE: ''
    };
  },
  computed: {
    ...mapGetters({
      getGamesActive:'games/getGamesActive'
    })
  },
  methods: {
/**
     * Función de animación dinámica (sube o baja)
     * @param {Object} rouletteItem - Objeto de ruleta reactivo.
     * @param {number} start - Valor desde donde empieza la animación (currentCount).
     * @param {number} end - Valor al que debe llegar la animación (nuevo valor del endpoint).
     * @param {number} duration - Duración de la animación en milisegundos.
     */
    animateValue(rouletteItem, start, end, duration) {
      // Si el valor no cambia, no hacemos nada.
      if (start === end) return; 

      let startTimestamp = null;
      const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);

        // Calcula el valor actual y lo redondea a un entero.
        const currentValue = Math.floor(progress * (end - start) + start);

        // Actualiza la propiedad visible (reactiva)
        rouletteItem.animatedCount = currentValue;

        if (progress < 1) {
          window.requestAnimationFrame(step);
        } else {
          // Asegurarse de que el valor final sea EXACTAMENTE el 'end'
          rouletteItem.animatedCount = end; 
          // Actualiza el valor interno (no visible) para que sea el 'start' de la siguiente animación
          rouletteItem.currentCount = end;
        }
      };
      window.requestAnimationFrame(step);
    },

    /**
     * Obtiene los datos del endpoint y actualiza los contadores.
     */
    async fetchAndUpdateCounts() {
      try {
        const {data} = await this.$socketApi.get('connections-all-rooms');
        
        // Creamos un mapa (Diccionario) para buscar rápidamente las conexiones por ID de sala.
        const connectionMap = data.reduce((acc, item) => {
            // Solo nos interesan las conexiones a las salas principales (id sin guiones)
            if (!item.room.includes('-')) {
                acc[item.room] = item.connections;
            }
            return acc;
        }, {});

        // 2. Itera sobre las ruletas reactivas para aplicar la animación
        this.roulettesWithCount.forEach(roulette => {
            // Obtener el nuevo valor o usar 0 si no se encuentra
            const newCount = connectionMap[roulette.id] || 0; 
            
            // Usar el valor interno (currentCount) como punto de partida ('start')
            const start = roulette.currentCount; 
            const end = newCount; 

            // Iniciar la animación
            this.animateValue(roulette, start, end, this.animationDuration);
        });

        // 2. Ordena el array 'roulettesWithCount'
        // El sort se hace sobre el array reactivo, lo que dispara una re-renderización del v-for.
        // Ordenamos por 'currentCount' (el valor real, que ya fue actualizado por la animación anterior).
        this.roulettesWithCount.sort((a, b) => b.currentCount - a.currentCount);

      } catch (error) {
        console.error("Error al obtener las conexiones:", error);
        // Opcional: Podrías mantener los contadores en su valor actual o resetearlos
      }
    },

    /**
     * Limpia el temporizador para evitar fugas de memoria.
     */
    stopPolling() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    },

    /**
     * Inicia la animación para cada ruleta.
     */
    startAllAnimations() {
        // Itera sobre el array de ruletas reactivas en 'roulettesWithCount'
        this.roulettesWithCount.forEach(roulette => {
            // Animamos de 0 (start) al targetCount que se pasa en la prop (end)
            this.animateValue(
                roulette, 
                0, // start
                roulette.targetCount || 100, // end (usando 100 como fallback)
                3000 // duration: 3000ms (3 segundos)
            );
        });
    },
    handleImageError(rouletteItem) {
      // 2. Comprueba que el logo actual no sea ya el placeholder
      // Esto evita un bucle infinito de errores si la URL del placeholder también falla
      if (rouletteItem.logo !== this.PLACEHOLDER_IMAGE) {
        // 3. Asigna la URL del placeholder al logo de la ruleta.
        // Vue detecta el cambio reactivo y actualiza el src de la imagen.
        rouletteItem.logo = this.PLACEHOLDER_IMAGE;
      }
    },
    getActivityWidth(count) {
      const maxCount = Math.max(...this.roulettesWithCount.map(r => r.animatedCount), 1)
      return `${(count / maxCount) * 100}%`
    },
    ...mapActions({
        fetchGames: 'games/fetchGames',
    })
  },

 async mounted() {
        await this.fetchGames({gameType: GamesTypes.Roulette})

        const image = await import('@/assets/images/users/pngegg.png');
      this.PLACEHOLDER_IMAGE = image.default;
    
    this.roulettesWithCount = this.getGamesActive.map(r => ({
        ...r,
        currentCount: 0, // Valor interno, no visible, usado como 'start' en la animación
        animatedCount: 0 // Valor visible que se anima
      }))

    // 3. Obtiene los datos la primera vez al montar el componente.
    this.fetchAndUpdateCounts(); 

    // 4. Configura la actualización periódica (polling)
    this.intervalId = setInterval(this.fetchAndUpdateCounts, this.refreshInterval);
  },

  beforeDestroy() {
    // 5. ¡Importante! Limpia el intervalo cuando el componente se destruye
    this.stopPolling();
  }
};
</script>

<style scoped>
.users-container {
  padding: 2rem;
  min-height: 100vh;
  background: linear-gradient(0deg, #e9d1e600 0%, #42396c 100%);
  border-radius: 5px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2.5rem;
  padding: 0 0.5rem;
}

.header__title {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 2rem;
  font-weight: 700;
  color: white;
  margin: 0;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.header__icon {
  font-size: 2.5rem;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

.refresh-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  color: white;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.refresh-btn:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
}

.refresh-btn i {
  font-size: 1.2rem;
  transition: transform 0.3s ease;
}

.refresh-btn:hover i {
  transform: rotate(180deg);
}

.grid-card {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.roulette-card {
  position: relative;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  padding: 1.5rem;
  transition: all 0.3s ease;
  overflow: hidden;
}

.roulette-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #667eea, #764ba2, #f093fb);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.roulette-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  border-color: rgba(255, 255, 255, 0.3);
}

.roulette-card:hover::before {
  opacity: 1;
}

.card-glow {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.roulette-card:hover .card-glow {
  opacity: 1;
}

.card-header {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin-bottom: 1.5rem;
  position: relative;
}

.card-thumb {
  width: 80px;
  height: 80px;
  border-radius: 16px;
  overflow: hidden;
  border: 3px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease;
}

.roulette-card:hover .card-thumb {
  transform: scale(1.05);
}

.card-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.status-indicator {
  position: absolute;
  top: 0;
  right: 0;
}

.status-dot {
  display: block;
  width: 12px;
  height: 12px;
  background: #10b981;
  border: 2px solid white;
  border-radius: 50%;
  box-shadow: 0 0 10px rgba(16, 185, 129, 0.8);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.7;
    transform: scale(1.1);
  }
}

.card-body {
  text-align: center;
  margin-bottom: 1rem;
}

.card-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: white;
  margin: 0 0 1rem 0;
  min-height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-count {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}

.count-number {
  font-size: 3rem;
  font-weight: 700;
  color: white;
  line-height: 1;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.count-label {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.9rem;
  font-weight: 500;
}

.count-label i {
  font-size: 1.1rem;
}

.card-footer {
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.activity-bar {
  width: 100%;
  height: 6px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  overflow: hidden;
}

.activity-fill {
  height: 100%;
  background: linear-gradient(90deg, #10b981, #3b82f6);
  border-radius: 10px;
  transition: width 0.5s ease;
  box-shadow: 0 0 10px rgba(16, 185, 129, 0.5);
}

@media (max-width: 768px) {
  .users-container {
    padding: 1.5rem;
  }

  .header {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }

  .header__title {
    font-size: 1.5rem;
    justify-content: center;
  }

  .refresh-btn {
    justify-content: center;
  }

  .grid-card {
    grid-template-columns: 1fr;
    gap: 1.25rem;
  }
}
</style>